import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { Button, Form, InputGroup } from "react-bootstrap";
import { preventMaxInput, validationRules } from "../Utils/constants";
import _, { isEmpty } from "lodash";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { IoMdArrowBack } from "react-icons/io";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import Slider from "react-slick";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import OutsideClickHandler from "react-outside-click-handler";


const Afiliates = () => {
  // const sendOTP = useContextSelector(AuthContext, (ctx) => ctx.sendOTP);
  const setBr = useContextSelector(AuthContext, (ctx) => ctx.setBr);
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  const setEn = useContextSelector(AuthContext, (ctx) => ctx.setEn);
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const { search } = useLocation();
  const affiliate = useContextSelector(AuthContext, (ctx) => ctx.affiliate);
  const [showPassword, setShowPassword] = useState(false);
  const [conPassToggle, setConPassTogle] = useState(false);
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    trigger,
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
  });
  useEffect(() => {
    if (!isEmpty(watch("confirmPassword"))) {
      if (watch("password")) {
        trigger("confirmPassword");
      }
    }
  }, [watch("password")]);
  const onSubmit = async (body) => {
    const { status, data } = await apiPost(apiPath.sendOTP, {});
    if (status === 200) {
      if (data.success) {
        toast.success(data?.message);
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
  };


 
  function copy(text) {
    toast.success("Link Copied!");
    return window.navigator.clipboard.writeText(text);
  }
  return (
  <>
  <div className="popup-page popup-page--active popup-page--align-top">
        <div className="popup-page__backdrop" />{" "}
        <OutsideClickHandler onOutsideClick={() => navigate(-1)}>
          <div className="popup-page__main popup-page-main popup-page-main--show">
            <div className="popup-page-main__header">
              <div className="popup-page-main__title">{t("Affiliates")}</div>
              <div
                onClick={() => navigate("/")}
                className="popup-page-main__close ng-star-inserted"
              />
            </div>
            <div className="popup-page-main__container">
              <div className="content login-biometric-content">
                <div className="referal_liks_top">
            <p>
              {t("Link_for_login")} -{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`https://ag.${window.location.hostname}/`}
                style={{ color: "lightblue" }}
              >
                {`https://ag.${window.location.hostname}/`}
              </a>
            </p>

            <p>
              {t("Link_to_refer")} -{" "}
              <span
                onClick={() => {
                  copy(`${window.location.origin}/register${search}`);
                }}
                style={{ color: "lightblue", cursor: "pointer" }}
              >
                {`${window.location.origin}/register${search}`}
              </span>
            </p>
          </div>
              </div>
            </div>
          </div>
        </OutsideClickHandler>
      </div>
      </>
      
  
  );
};

export default Afiliates;
